import { render, staticRenderFns } from "./StakingItem.vue?vue&type=template&id=7ebfdc8c&scoped=true"
import script from "./StakingItem.vue?vue&type=script&lang=js"
export * from "./StakingItem.vue?vue&type=script&lang=js"
import style0 from "./StakingItem.vue?vue&type=style&index=0&id=7ebfdc8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ebfdc8c",
  null
  
)

export default component.exports